import { Box, ColorOptions, Icon, Loader, Spacer, Text } from '@jfs/ui-new'
import { FC } from 'react'
import LinearGradient from 'react-native-linear-gradient'

interface GradientButtonProps {
  title?: string
  onPress?: () => void
  width?: number | string
  height?: number
  borderRadius?: number
  isLoading?: boolean
  disabled?: boolean
  icon?: string
  testID?: string
  hide?: boolean
  fontSize?: number
}

/**
 * Primary action button whose background uses the same navy -> teal gradient as
 * the left side menu bar. Admin-portal only.
 */
export const GradientButton: FC<GradientButtonProps> = ({
  title,
  onPress,
  width,
  height = 40,
  borderRadius = 4,
  isLoading = false,
  disabled = false,
  icon,
  testID,
  hide = false,
  fontSize = 14,
}) => {
  if (hide) {
    return null
  }
  const isInteractive = !disabled && !isLoading
  return (
    <Box
      testID={testID}
      onPress={isInteractive ? onPress : undefined}
      underlayColor={'TRANSPARENT'}
      opacity={disabled ? 0.6 : 1}
      borderRadius={borderRadius}
      overflow={'hidden'}
      style={{ width: width as any }}>
      <LinearGradient
        colors={['#214796', '#1F71A2']}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 0 }}
        style={{
          minHeight: height,
          borderRadius,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          paddingHorizontal: 16,
        }}>
        {isLoading ? (
          <Loader type="small" color="WHITE" />
        ) : (
          <>
            {!!icon && <Icon id={icon} color={'WHITE' as ColorOptions} size={16} />}
            {!!icon && !!title && <Spacer direction={'horizontal'} size={6} />}
            {!!title && (
              <Text color={'WHITE'} fontFamily={'jiotype-medium'} fontSize={fontSize} numberOfLines={1}>
                {title}
              </Text>
            )}
          </>
        )}
      </LinearGradient>
    </Box>
  )
}
